export default class ActionQueryInterpreter {
    constructor(router) {
    this.router =router;
    }
    execute($actionQuery) {
        let type = $actionQuery.type;
        this[type]($actionQuery.params);
    }

    link({to, params}){
        this.router.go(to, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/action-query-interpreter.js